import { render, staticRenderFns } from "./FooterChannelMob.vue?vue&type=template&id=7c7dad98&scoped=true"
import script from "./FooterChannelMob.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterChannelMob.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterChannelMob.vue?vue&type=style&index=0&id=7c7dad98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7dad98",
  null
  
)

export default component.exports